import { motion } from 'framer-motion'

const reasons = [
  {
    num: '01',
    headline: "We don't pitch. We search.",
    body: "A mandate is not a slot to fill. Before we open a brief, we spend time understanding the organisational context, the operating model, and what a genuine success looks like twelve months from now.",
  },
  {
    num: '02',
    headline: 'Our network precedes the mandate.',
    body: 'The most transformational hires rarely apply. They are approached — because we have mapped the market, maintained the relationships, and earned the trust to have honest conversations about what they actually want.',
  },
  {
    num: '03',
    headline: 'We advise on structure before we hire.',
    body: "Should this be a VP role or a Director? Should the site head report locally or to the global CTO? We ask these questions — and challenge the brief — before we present a single name.",
  },
  {
    num: '04',
    headline: 'Long-term fit is the only fit.',
    body: 'Our placements are measured over years, not months. We track outcomes. We celebrate when leaders thrive, and we take responsibility when they do not.',
  },
  {
    num: '05',
    headline: 'We are operators, not intermediaries.',
    body: 'Strive Partners was built by people who have led teams inside GCCs and technology firms. We understand both sides of the table — what it takes to hire well, and what it takes to be hired well.',
  },
]

export default function WhyStriveSection() {
  return (
    <section
      data-testid="why-strive-section"
      className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-20"
        >
          <p className="text-[10px] tracking-[0.35em] uppercase text-[#0A0A0A]/30 mb-5 font-body font-semibold">
            Why Strive Partners
          </p>
          <h2 className="text-[clamp(2.5rem,5vw,5rem)] font-heading font-black tracking-tighter leading-none text-[#0A0A0A]">
            Five things we<br />
            <span className="font-light text-[#16365F]">believe in.</span>
          </h2>
        </motion.div>

        <div className="border-t border-[#E5E7EB]">
          {reasons.map((r, i) => (
            <motion.div
              key={r.num}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.07 }}
              className="py-10 border-b border-[#E5E7EB] grid grid-cols-1 md:grid-cols-[80px_1fr_2fr] gap-4 md:gap-10 group"
              data-testid={`why-strive-item-${i + 1}`}
            >
              <p className="text-[9px] tracking-[0.3em] uppercase text-[#0A0A0A]/20 font-body font-semibold pt-1">
                {r.num}
              </p>
              <h3 className="text-lg font-heading font-black text-[#0A0A0A] leading-tight tracking-tight">
                {r.headline}
              </h3>
              <p className="text-sm font-body text-[#0A0A0A]/55 leading-relaxed">
                {r.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
